import React from "react";
import { CrewPilotModuleShell } from "../../components/CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import { DeskEmpty, DeskPanel, DeskSearch } from "../../components/desktop/DeskTable";
import { getAshleyCapabilityStatusMeta } from "./ashleyCapabilityStatus";
import "../../components/desktop/deskKit.css";
import "./ashleyHomeDesktop.css";

/**
 * Desktop Ashley Home: category list (master) beside the selected category's
 * capabilities and example phrases (detail). Presentation only — same catalog,
 * search and selection state as the phone accordion.
 */
export function AshleyHomeDesktop({ onBack, searchText, onSearch, catalog, selectedId, onSelect }) {
  const selected = catalog.find((category) => category.id === selectedId) || catalog[0] || null;

  return (
    <CrewPilotModuleShell
      title="Ashley"
      subtitle="What can I help you with today? Browse my capabilities or simply ask me naturally."
      layout={PAGE_LAYOUT.COMMAND}
      onBack={onBack}
      backLabel="Dashboard"
      compact
      headerActions={
        <div className="cdh-actions">
          <DeskSearch value={searchText} onChange={onSearch} placeholder="Search Ashley's capabilities..." ariaLabel="Search Ashley's capabilities" />
        </div>
      }
    >
      {catalog.length === 0 || !selected ? (
        <DeskEmpty title="Nothing matches that search">Try email, payroll, briefing, or session.</DeskEmpty>
      ) : (
        <div className="ah-desk">
          <nav className="ah-desk__list" aria-label="Ashley capability categories">
            {catalog.map((category) => (
              <button
                key={category.id}
                type="button"
                className={`ah-desk__cat${category.id === selected.id ? " is-on" : ""}`}
                aria-current={category.id === selected.id ? "true" : undefined}
                onClick={() => onSelect(category.id)}
              >
                <span className="ah-desk__cat-icon" aria-hidden="true">{category.icon}</span>
                <span className="ah-desk__cat-title">{category.title}</span>
                <span className="ah-desk__cat-count" aria-label={`${category.capabilities.length} capabilities`}>{category.capabilities.length}</span>
              </button>
            ))}
          </nav>

          <div className="ah-desk__detail">
            <DeskPanel title={`What Ashley can do — ${selected.title}`}>
              <ul className="ah-desk__caps">
                {selected.capabilities.map((capability) => {
                  const meta = getAshleyCapabilityStatusMeta(capability.status);
                  return (
                    <li key={capability.id} className="ah-desk__cap">
                      <span className={`ashley-home__status ashley-home__status--${meta.indicator}`} title={meta.label} aria-label={meta.label} />
                      <span>
                        <strong>{capability.title}</strong>
                        {capability.description ? <span className="ah-desk__cap-desc">{capability.description}</span> : null}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </DeskPanel>
            <DeskPanel title="Example phrases">
              <p className="dp-hint">Say it naturally — exact wording isn&apos;t required.</p>
              <ul className="ah-desk__phrases">
                {selected.capabilities.flatMap((capability) =>
                  (capability.examplePhrases || []).map((phrase) => (
                    <li key={`${capability.id}:${phrase}`}>{phrase}</li>
                  )),
                )}
              </ul>
            </DeskPanel>
          </div>
        </div>
      )}
    </CrewPilotModuleShell>
  );
}
